import { render, staticRenderFns } from "./RevenueShareTopSection.vue?vue&type=template&id=5831fde5&scoped=true&"
import script from "./RevenueShareTopSection.vue?vue&type=script&lang=js&"
export * from "./RevenueShareTopSection.vue?vue&type=script&lang=js&"
import style0 from "./RevenueShareTopSection.vue?vue&type=style&index=0&id=5831fde5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5831fde5",
  null
  
)

export default component.exports